<div tabindex="-1" #modalroot aria-modal="true" role="dialog" class="modal"
  [class.fade]="fade"
  [attr.aria-labelledby]="labelledBy"
  [attr.aria-describedby]="describedBy">
  <div class="modal-dialog">
    <div class="modal-content" tabindex="0">
      <ng-content select="pru-modal-header"></ng-content>
      <ng-content select="pru-modal-body"></ng-content>
      <ng-content select="pru-modal-footer"></ng-content>
    </div>
  </div>
</div>
